import { TbRobot } from 'react-icons/tb';
import styles from './WhatsAppMockup.module.css';

const WhatsAppMockup = ({ messages = [], looping = true }) => (
  <div className={styles.phone}>
    {/* Header simulado (canal WhatsApp) */}
    <div className={styles.header}>
      <div className={styles.avatar} aria-hidden="true">
        <TbRobot />
      </div>
      <div>
        <div className={styles.botName}>Nexus Bot</div>
        <div className={styles.botStatus}>online agora</div>
      </div>
    </div>

    {/* Mensagens */}
    <div className={looping ? styles.looping : undefined}>
      {messages.map((m, i) => (
        <div
          key={i}
          className={[
            styles.row,
            m.type === 'out' ? styles.rowOut : styles.rowIn,
          ].join(' ')}
          style={{ animationDelay: `${i * 1.5}s` }}
        >
          <span
            className={[
              styles.bubble,
              m.type === 'out' ? styles.bubbleOut : styles.bubbleIn,
            ].join(' ')}
          >
            {m.text}
          </span>

          {/* Botões pill (apenas em mensagens do bot) */}
          {m.buttons && m.type === 'in' && (
            <div className={styles.buttons}>
              {m.buttons.map((btn, j) => (
                <span key={j} className={styles.pill}>
                  {btn}
                </span>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default WhatsAppMockup;
